import Swiper from '../vendors/swiper.min';

export default function categoryCarousel() {
    const category = $('#category-carousel');
    const category_options = {
        loop: true,
        spaceBetween: 0,
        speed: 800,
        pagination: {
            el: '#category-pagination',
            type: 'bullets',
            clickable: 'true'
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        }
    };

    if (category.length) {
        const category_carousel = new Swiper(category, category_options);
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/category-page-carousel.js